<template>
    <div class="general-comments">
        <div
            class="comments-header"
            v-b-toggle="`general-comments-${questionnaireId}`"
        >
            <div class="title">{{ $t('values.generalComments') }}</div>
            <i
                v-b-tooltip.hover
                style="color: #6e6e6e"
                class="fas fa-question-circle"
                :title="$t('values.generalCommentsDescription')"
            />
        </div>
        <b-collapse
            class="comments-content"
            :id="`general-comments-${questionnaireId}`"
        >
            <comments :comments="comments" />
        </b-collapse>
    </div>
</template>
<script>
import Comments from './Comments'
export default {
    components: {
        Comments,
    },
    props: {
        questionnaireId: String | Number,
        comments: {
            type: Array,
            required: true,
        },
    },
}
</script>
<style lang="sass" scoped>
.general-comments
    .comments-header
        display: flex
        align-items: center
        margin-bottom: 10px
        padding: 11px
        border-radius: 5px
        cursor: pointer
        background-color: #eeeeee

        .title
            margin-right: 10px

    .comments-content
        padding: 6px 16px 6px 16px
        box-shadow: 0px 2.5px 2.5px rgba(0, 0, 0, 0.2)
</style>
